import { gql } from 'apollo-angular';

// Contract with the backend DashboardResolver — spec §1 of
// docs/superpowers/specs/2026-09-24-dashboard-design.md. Every root field name and
// every selected field is copied verbatim from that table: renaming one here without
// the backend changing too surfaces only as a GraphQL validation error at runtime (the
// widget's inline error state). dashboardShipmentsStatus is deliberately absent — cut
// from the MVP (spec §0.0).

export const GET_DASHBOARD_PROPOSALS_BY_STATUS = gql`
  query DashboardProposalsByStatus {
    dashboardProposalsByStatus {
      status
      count
      totalValue
    }
  }
`;

export const GET_DASHBOARD_PIPELINE_VALUE = gql`
  query DashboardPipelineValue {
    dashboardPipelineValue {
      totalValue
      deltaVsLastMonth
    }
  }
`;

export const GET_DASHBOARD_CONVERSION_RATE = gql`
  query DashboardConversionRate {
    dashboardConversionRate {
      sentCount
      acceptedCount
      ratePercent
    }
  }
`;

export const GET_DASHBOARD_FOLLOW_UP_NEEDED = gql`
  query DashboardFollowUpNeeded {
    dashboardFollowUpNeeded {
      proposalId
      reference
      clientName
      daysSinceSent
    }
  }
`;

export const GET_DASHBOARD_STALE_CLIENTS = gql`
  query DashboardStaleClients {
    dashboardStaleClients {
      clientId
      clientName
      daysSinceLastProposal
    }
  }
`;

export const GET_DASHBOARD_SALES_TARGET = gql`
  query DashboardSalesTarget {
    dashboardSalesTarget {
      targetValue
      achievedValue
      progressPercent
    }
  }
`;

export const GET_DASHBOARD_ACTIVITY_STREAK = gql`
  query DashboardActivityStreak {
    dashboardActivityStreak {
      days
    }
  }
`;

export const GET_DASHBOARD_MILESTONES = gql`
  query DashboardMilestones {
    dashboardMilestones {
      acceptedCount
      earnedThresholds
      nextThreshold
    }
  }
`;

export const GET_DASHBOARD_LEADERBOARD = gql`
  query DashboardLeaderboard {
    dashboardLeaderboard {
      userId
      name
      achievedValue
      targetValue
    }
  }
`;

export const GET_DASHBOARD_PENDING_OFFERS = gql`
  query DashboardPendingOffers {
    dashboardPendingOffers {
      count
    }
  }
`;

export const GET_DASHBOARD_TOP_CLIENTS = gql`
  query DashboardTopClients {
    dashboardTopClients {
      clientId
      clientName
      totalValue
    }
  }
`;

export const GET_DASHBOARD_TOP_SPECIES = gql`
  query DashboardTopSpecies {
    dashboardTopSpecies {
      speciesId
      speciesName
      totalVolume
    }
  }
`;

export const SET_DASHBOARD_SALES_TARGET = gql`
  mutation DashboardSalesTargetSet(
    $userId: Int!
    $year: Int!
    $month: Int!
    $targetValue: Float!
  ) {
    dashboardSalesTargetSet(
      userId: $userId
      year: $year
      month: $month
      targetValue: $targetValue
    ) {
      id
      userId
      year
      month
      targetValue
    }
  }
`;
